export const PROGRESS_STATUSES = Object.freeze({
  STARTED: "started",
  COMPLETED: "completed",
  FAILED: "failed",
});

export const PROGRESS_TASK_CONFIG = Object.freeze({
  pipeline: {
    titles: {
      started: "در حال پردازش درخواست",
      completed: "پردازش درخواست تکمیل شد",
      failed: "پردازش درخواست ناموفق بود",
    },
  },

  guardrail:{
    titles: {
      started: "در حال بررسی امنیتی پرسش",
      completed: "بررسی امنیتی تکمیل شد",
      failed: "بررسی امنیتی ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

  refinement:{
    titles: {
      started: "در حال فهم بهتر پرسش",
      completed: "فهم بهتر پرسش تکمیل شد",
      failed: "فهم بهتر پرسش ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },


  retrieval: {
    titles: {
      started: "در حال جستجوی اطلاعات مرتبط",
      completed: "جستجوی اطلاعات تکمیل شد",
      failed: "جستجوی اطلاعات ناموفق بود",
    },

    detailLabels:{
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
      embedding_model: "مدل تعبیه",
      embedding_provider: "ارائه‌دهنده مدل تعبیه",
      embedding_address: "نشانی مدل تعبیه"
    }
  },

  retrievalvalidation: {
    titles: {
      started: "در حال بررسی اطلاعات بازیابی شده",
      completed: "بررسی اطلاعات بازیابی شده تکمیل شد",
      failed: "بررسی اطلاعات بازیابی شده ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

  generation: {
    titles: {
      started: "در حال تولید پاسخ",
      completed: "پاسخ با موفقیت تولید شد",
      failed: "تولید پاسخ ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

  validation: {
    titles: {
      started: "در حال بررسی پاسخ",
      completed: "بررسی پاسخ تکمیل شد",
      failed: "بررسی پاسخ ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

  nl2sql:{
    titles: {
      started: "در حال طراحی و بررسی پرس و جو",
      completed: "طراحی و بررسی پرس و جو تکمیل شد",
      failed: "طراحی و بررسی پرس و جو ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },


  execution:{
    titles: {
      started: "در حال اجرای پرس و جو",
      completed: "اجرای پرس و جو تکمیل شد",
      failed: "اجرای پرس و جو ناموفق بود",
    },

    detailLabels: {
      provider: "ارائه‌دهنده",
    },
  },

  intent:{
    titles: {
      started: "در حال تحلیل نتیجه پرس و جو",
      completed: "تحلیل نتیجه پرس و جو تکمیل شد",
      failed: "تحلیل نتیجه پرس و جو ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

  chart:{
    titles: {
      started: "در حال طراحی بازنمایی و تولید نمودار",
      completed: "طراحی بازنمایی و تولید نمودار تکمیل شد",
      failed: "طراحی بازنمایی و تولید نمودار ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

  report:{
    titles: {
      started: "در حال تولید گزارش",
      completed: "تولید گزارش نمودار تکمیل شد",
      failed: "تولید گزارش نمودار ناموفق بود",
    },

    detailLabels: {
      model: "مدل",
      provider: "ارائه‌دهنده",
      address: "نشانی سرویس",
    },
  },

});

const DEFAULT_DETAIL_LABELS = Object.freeze({
  message: "توضیحات",
  model: "مدل",
  provider: "ارائه‌دهنده",
  address: "نشانی",
  elapsed_time: "زمان اجرا",
  error: "خطا",
});

const HIDDEN_DETAIL_KEYS = new Set([
  "request_id",
  "progress_id",
  "task",
  "status",
  "id",
  "recievedAt"
]);

export function normalizeTaskName(task) {
  return String(task || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

export function getProgressTaskConfig(task) {
  const normalizedTask = normalizeTaskName(task);

  return (
    PROGRESS_TASK_CONFIG[normalizedTask] || {
      titles: {
        started: `در حال انجام ${task || "عملیات"}`,
        completed: `${task || "عملیات"} تکمیل شد`,
        failed: `${task || "عملیات"} ناموفق بود`,
      },
    }
  );
}

export function getProgressTitle(event) {
  const config = getProgressTaskConfig(event.task);

  return (
    config.titles[event.status] ||
    config.titles.started ||
    event.task
  );
}

function formatDetailValue(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "boolean") {
    return value ? "بله" : "خیر";
  }

  if (Array.isArray(value)) {
    return value
      .map(formatDetailValue)
      .filter(Boolean)
      .join("، ");
  }

  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }

  return String(value);
}

export function getProgressDetails(event) {
  const config = getProgressTaskConfig(event.task);

  const labels = {
    ...DEFAULT_DETAIL_LABELS,
    ...(config.detailLabels || {}),
  };

  return Object.entries(event)
    .filter(([key]) => !HIDDEN_DETAIL_KEYS.has(key))
    .map(([key, value]) => {
      const formattedValue = formatDetailValue(value);

      if (!formattedValue) {
        return null;
      }

      /*
       * Display "message" directly because it is normally
       * a complete subtitle sent by the backend.
       */
      if (key === "message") {
        return {
          key,
          label: null,
          value: formattedValue,
        };
      }

      return {
        key,
        label: labels[key] || key,
        value: formattedValue,
      };
    })
    .filter(Boolean);
}